import logo from './logo.svg';
import './App.css';
import ValentineApp from './ValentineApp';

function App() {
  return (
    <div className="App">
      <ValentineApp />
      
    </div>
  );
}

export default App;
